import { QueryState as SharedQueryState } from '@central/ui';
import { errorMessage } from '../format';

/** Loading spinner or error alert for a query that has no data yet, in the portal's words. */
export function QueryState({ error }: { error: unknown }) {
  return (
    <SharedQueryState error={error} title="Couldn’t load this page" describeError={errorMessage} />
  );
}
